import { CommunityContainer } from "./styled"

const Community = () => {
  return (
    <CommunityContainer>Community</CommunityContainer>
  )
}

export default Community